<template>
  <SiteTable />
</template>

<script>
import SiteTable from "@/components/site/SiteTable.vue";

export default {
  name: 'SiteView',
  components: {SiteTable},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
